export const US_REGION_NAME = 'us-west-2';
export const EU_REGION_NAME = 'eu-west-2';
export const AP_REGION_NAME = 'ap-southeast-2';
export const US_REGION_SHORT_NAME = 'uw2';
export const EU_REGION_SHORT_NAME = 'ew2';
export const AP_REGION_SHORT_NAME = 'as2';
